import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { Injectable, OnDestroy } from '@angular/core';
import { ConfigService } from '@stockcare-services/config-service/config.service';
import { DeviceService } from '@stockcare-services/devices-service/devices.service';
import { Subscription } from 'rxjs';

@Injectable()
export class ApplicationInsightsService implements OnDestroy {
  appInsights: ApplicationInsights;
  applicationInsightsInstrumentationKey: string;
  subscriptions = new Subscription();

  constructor(private configurationService: ConfigService, private deviceService: DeviceService) {}

  initialize() {
    this.subscriptions.add(
      this.configurationService.configLoaded.subscribe((isLoaded) => {
        if (isLoaded) {
          this.applicationInsightsInstrumentationKey = this.configurationService.config.applicationInsightsInstrumentationKey;
          if (this.applicationInsightsInstrumentationKey) {
            this.appInsights = new ApplicationInsights({
              config: {
                instrumentationKey: this.applicationInsightsInstrumentationKey,
                enableAutoRouteTracking: true,
              },
            });
            this.appInsights.loadAppInsights();
          }
        }
      })
    );
  }

  logPageView(name?: string, url?: string) {
    if (!this.appInsights) {
      return;
    }

    this.appInsights.trackPageView({
      name: name,
      uri: url,
    });
  }

  logEvent(name: string, properties: { [key: string]: any } = {}) {
    if (!this.appInsights) {
      return;
    }

    const device = this.deviceService.getDeviceFromLocalStorage();

    if (device !== null) {
      properties['deviceId'] = device.deviceId;
      properties['institutionName'] = device.institutionName;
      properties['stockLocationName'] = device.stockLocationName;
      properties['physicalLocationName'] = device.physicalLocationName;
      properties['institutionId'] = device.institutionId;
      properties['stockLocationId'] = device.stockLocationId;
      properties['physicalLocationId'] = device.physicalLocationId;
      properties['deviceName'] = device.name;
      properties['lastHeartbeatReceived'] = device.lastHeartbeatReceived;
    }

    this.appInsights.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    if (!this.appInsights) {
      return;
    }

    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    if (!this.appInsights) {
      return;
    }

    this.appInsights.trackException({
      exception: exception,
      severityLevel: severityLevel,
    });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    if (!this.appInsights) {
      return;
    }

    this.appInsights.trackTrace({ message: message }, properties);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
